module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "course"
  }, [_vm._v("\n    " + _vm._s(_vm.weekChange) + " " + _vm._s(_vm.timelineEvents) + "\n\n    "), _c('timeline'), _vm._v(" "), (_vm.course) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.course.name))]), _vm._v(" "), _c('span', {
    staticClass: "instructor-name"
  }, [_vm._v("by " + _vm._s(_vm.instructors))]), _vm._v(" "), _c('div', {
    staticClass: "course-description"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.course.description)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel week-at-a-glance"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Week at a Glance"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('See all weekly events for this course. The table below will show you what this course contains: title, description, video lesson, feedback and live session archive'),
      expression: "'See all weekly events for this course. The table below will show you what this course contains: title, description, video lesson, feedback and live session archive'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.weekdays), function(weekday) {
    return _c('li', {
      staticClass: "weekday",
      class: _vm.dayBackground(weekday.abbreviation)
    }, [_c('div', [_vm._v("\n                                        " + _vm._s(weekday.name) + "\n                                        "), (_vm.hasEvent(weekday.abbreviation)) ? _c('span', {
      staticClass: "pin",
      class: _vm.event(weekday.abbreviation).type,
      on: {
        "click": function($event) {
          _vm.goToEvent(_vm.event(weekday.abbreviation))
        }
      }
    }) : _vm._e()])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.meetings && _vm.videos) ? _c('ul', {
    staticClass: "course-weeks clearfix panel",
    attrs: {
      "id": "course-weeks"
    }
  }, _vm._l((_vm.videos), function(video, index) {
    return _c('li', {
      staticClass: "row",
      class: {
        'current-week': video.week === _vm.currentWeek
      },
      style: ({
        'background-color': _vm.backgroundColor(video.color, index)
      }),
      attrs: {
        "id": 'week-' + index
      }
    }, [_c('div', {
      staticClass: "col-md-2 toggle-week",
      on: {
        "click": function($event) {
          _vm.toggleRow(index)
        }
      }
    }, [(_vm.rowsToShow.indexOf(index) > -1) ? _c('i', {
      staticClass: "fa fa-minus"
    }) : _vm._e(), _vm._v(" "), (_vm.rowsToShow.indexOf(index) === -1) ? _c('i', {
      staticClass: "fa fa-plus"
    }) : _vm._e(), _vm._v("\n                        Week " + _vm._s(video.week) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('h4', [_vm._v(_vm._s(video.title))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rowsToShow.indexOf(index) > -1),
        expression: "rowsToShow.indexOf(index) > -1"
      }],
      staticClass: "description"
    }, [_vm._v(_vm._s(video.summary))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [(video.video_chapters &&
      video.video_chapters[0] &&
      (video.weekAvailable <= _vm.currentWeek || new Date(_vm.term.endDate) < new Date() || _vm.localStorage.user_id == '4' || _vm.localStorage.user_id == '333')) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'videoPlayer',
          query: {
            week: video.week
          },
          params: {
            instanceId: _vm.instanceId,
            videoId: video.id
          }
        }
      }
    }, [_c('img', {
      staticClass: "view-video",
      attrs: {
        "src": require("../assets/img/play-button-small-blue.png")
      }
    }), _vm._v("View Video\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rowsToShow.indexOf(index) > -1),
        expression: "rowsToShow.indexOf(index) > -1"
      }]
    }, [(video.video_chapters &&
      video.video_chapters[0] &&
      (video.weekAvailable <= _vm.currentWeek || new Date(_vm.term.endDate) < new Date() || _vm.localStorage.user_id == '4' || _vm.localStorage.user_id == '333')) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'videoPlayer',
          query: {
            week: video.week
          },
          params: {
            instanceId: _vm.instanceId,
            videoId: video.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "video-thumbnail"
    }, [_c('img', {
      attrs: {
        "src": video.video_chapters[0].thumbnail
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "play-button",
      attrs: {
        "src": require("../assets/img/play-button.png")
      }
    })])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [(_vm.assignments && _vm.hasAssignment(video)) ? _c('div', [(_vm.assignments && _vm.hasFeedback(video)) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.playFeedback(video.week)
        }
      }
    }, [_c('img', {
      staticClass: "view-video",
      attrs: {
        "src": require("../assets/img/play-button-small-green.png")
      }
    })]) : _c('img', {
      staticClass: "view-video inactive",
      attrs: {
        "src": require("../assets/img/play-button-small-grey.png")
      }
    }), _vm._v(" "), (_vm.assignments && _vm.hasFeedback(video.week)) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.playFeedback(video.week)
        }
      }
    }, [_vm._v("Feedback")]) : _c('a', {
      staticClass: "inactive"
    }, [_vm._v("Feedback")])]) : _vm._e(), _vm._v(" "), (_vm.assignments && _vm.hasFeedback(video.week)) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rowsToShow.indexOf(index) > -1),
        expression: "rowsToShow.indexOf(index) > -1"
      }]
    }, [_c('div', {
      staticClass: "video-thumbnail",
      on: {
        "click": function($event) {
          _vm.playFeedback(video.week)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../assets/img/feedback-thumb.jpg")
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "play-button",
      attrs: {
        "src": require("../assets/img/play-button.png")
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [(_vm.meetingForWeek(video.week)) ? _c('a', {
      attrs: {
        "href": _vm.meetingForWeek(video.week).archiveUrl,
        "target": "_blank"
      }
    }, [_vm._v("\n                            Live Session\n                            "), (_vm.meetingForWeek(video.week).secondaryRecordings && _vm.meetingForWeek(video.week).secondaryRecordings.length > 0) ? _c('span', [_vm._v("\n                                (\n                                "), _c('a', {
      staticClass: "recording",
      attrs: {
        "href": _vm.meetingForWeek(video.week).archiveUrl,
        "target": "_blank"
      }
    }, [_vm._v("1")]), _vm._v(" "), _vm._l((_vm.meetingForWeek(video.week).secondaryRecordings), function(recording, index) {
      return _c('span', [_vm._v(",\n                                    "), _c('a', {
        staticClass: "recording",
        attrs: {
          "href": recording,
          "target": "_blank"
        }
      }, [_vm._v(" " + _vm._s(index + 2) + " ")])])
    }), _vm._v(")\n                            ")], 2) : _vm._e()]) : _c('a', {
      staticClass: "inactive"
    }, [_vm._v("Live Session")])])])
  })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.course && _vm.assignments) ? _c('div', {
    staticClass: "panel col-sm-12 has-course-table"
  }, [_c('div', {
    staticClass: "panel-heading assignments"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/img/assignment-icon.png")
    }
  }), _vm._v("Assignments"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('A sortable assignment table including due dates, marks and recorded feedback.'),
      expression: "'A sortable assignment table including due dates, marks and recorded feedback.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('assignments-table', {
    attrs: {
      "assignments": _vm.assignments
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7916ff76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Course.vue
// module id = 2086
// module chunks = 2